export default {
  refundRecord_00001: "退款记录",
  refundRecord_00002: "退款日期",
  refundRecord_00003: "退款金额({0})",
  refundRecord_00004:'系统自动退款（微信支付）',
  refundRecord_00005:'系统自动退款（支付宝）',
  refundRecord_00006: '{name}人工退款',
}